import { memo, useCallback } from 'react'
import './Information.css'
import { _uploadEye } from '@/api/user'
import useHistory from '@/hooks/useHistory'
import dd from '@/utils/dd.config'

const Information = ({ item, onClick }) => {

  const history = useHistory()

  const handleDetail = useCallback(() => {
    _uploadEye({ type: 1, bpId: item.id }).then(() => {
      onClick && onClick()
    })
    if (item.id <= 2 ) {
      history.push('/InformationDetail?id=' + item.id)
    }else {
      if (item.pageUrl) {
        history.push(item.pageUrl)
      }else {
        dd.openLink(item.url)
      }
    }
  }, [item])

  return <div onClick={handleDetail} className="com-information">
    <div className="com-information-left">
      <div className="com-information-title clamp3">
        { item.title }
      </div>
      <div className="com-information-footer">
        <span className="com-information-date">
          { item.date }
        </span>
        <span className="com-information-look">
          <img className="com-information-eye" src="http://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/eye.png" alt="加载中" />
          { item.eye }
        </span>
      </div>
    </div>
    <img className="com-information-right" src={item.img} alt="加载中" />
  </div>
}

export default memo(Information)
